import { Navigate, Route, Routes } from "react-router-dom"

import { useGetEnabledModulesInApp } from "@l2r-front/l2r-networks"
import { BottomSheetMobileLayout } from "@l2r-front/l2r-ui"

import { IncidentsMobileRoutes } from "../../../modules/incidents/routers/IncidentsRoutes"
import { RiskZonesMapLayersRouter } from "../../../modules/riskZones/routers/RiskZonesMapLayersRouter"
import { RiskZonesMobileRoutes } from "../../../modules/riskZones/routers/RiskZonesRoutes"
import { SpeedingsMapLayersRouter } from "../../../modules/speedings/routers/SpeedingsMapLayersRouter"
import { SpeedingsMobileRoutes } from "../../../modules/speedings/routers/SpeedingsRoutes"
import { appSafety } from "../../constants/appSafety"
import { MODULE_INCIDENTS, MODULE_RISK_ZONES, MODULE_SPEEDINGS } from "../../constants/modules"
import { Map } from "../../containers/Map"

export function SafetyMobileRouter() {

    const enabledRoadModule = useGetEnabledModulesInApp(appSafety)

    return (
        <Routes>
            <Route
                path={`/${MODULE_INCIDENTS}/*`}
                element={<IncidentsMobileRoutes />}
            />
            <Route
                path={`/${MODULE_RISK_ZONES}/*`}
                element={<BottomSheetMobileLayout BottomSheetRouter={RiskZonesMobileRoutes} MapComponent={Map} MapRouter={RiskZonesMapLayersRouter} />}
            />
            <Route
                path={`/${MODULE_SPEEDINGS}/*`}
                element={<BottomSheetMobileLayout BottomSheetRouter={SpeedingsMobileRoutes} MapComponent={Map} MapRouter={SpeedingsMapLayersRouter} />}
            />
            <Route
                path="/*"
                element={<Navigate replace to={enabledRoadModule?.[0]?.path ? enabledRoadModule?.[0]?.path : ""} />}
            />
        </Routes>
    )
}
